import React from 'react';
import ReactDom from 'react-dom';
import "./resource/style/index.scss";
import SoftPhoneWithProviders from './SoftPhoneWithProviders';

const wrapper = document.createElement('div');
wrapper.classList.add('softphone-wrapper')
document.body.appendChild(wrapper);

ReactDom.render(
    <SoftPhoneWithProviders widget={true} />,
    wrapper
);

wrapper.replaceWith(...wrapper.childNodes);

const links = document.querySelectorAll('a[href^="tel:"]');
links.forEach((element) => {
    element.addEventListener('click', (event) => {
        event.preventDefault();
        window.dispatchEvent(new CustomEvent('softphone:call-number', {
            detail: { number: element.getAttribute('href') }
        }));
    })
});
